import {RampIdType} from '../../../../generated/graphql';
import {useEntityFlagFromStore} from '../../../../util/rampFeatureFlags/stores/useRampFlagStore';

/**
 * Whether the entity is ramped into group-runs v2 querying. Same entity gate
 * gorilla checks before the v2 path where "Stabilize run groups" has effect
 * (`GORILLA_GATE_GROUP_RUNS_V2_QUERYING_ENTITY` / `group_runs_v2_querying_entity`).
 */
export function useGroupRunsV2QueryingEnabled(): boolean {
  return useEntityFlagFromStore(
    'group_runs_v2_querying_entity',
    RampIdType.EntityId
  );
}
